
/**
 * @description 省版
 */
export const isShengban =  process.env.VUE_APP_PLATFORM === 'shengban'
/**
 * @description 市版
 */
export const isShiban = process.env.VUE_APP_PLATFORM === 'shiban'